var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"edit-resource-modal"}},[_c('resource-details-form',{attrs:{"isEditMode":"","resource":_vm.getResource,"isWaiting":_vm.isWaiting},on:{"save":_vm.editMedia,"cancel":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }